import List from "@/components/list";
import router from "@/router";
import Bus from "./bus";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const expandChange = listeners["expand-change"] || function() {};
  const changePort = listeners["change-port"] || function() {};

  // 删除视频
  async function deleteVideo(uuid) {
    Bus.$emit("deleteVideo", uuid);
  }

  // 上下线视频
  function onlineVideo(video) {
    Bus.$emit("onlineVideo", {
      id: [video.uuid],
      type: "上下线",
      status: video.onlineStatus,
      deptId: video.deptId,
      isExpired: video.isExpired,
      // 如果有 parentId 说明是共享来的资源，不显示上线后cdn按钮
      showOnlineCdn: video.parentId ? false : true,
    });
  }

  // 上下线申请
  function onlineVideoApply(video) {
    Bus.$emit("onlineVideoApply", {
      type: "上下线申请",
      id: [video.uuid],
      status: video.onlineStatus,
      deptId: video.deptId,
    });
  }

  function shareManage(id) {
    Bus.$emit("shareManage", id);
  }

  function qrcodeClick(val) {
    Bus.$emit("qrcodeClick", val);
  }

  const Deal = ({ props: { vo } }) => {
    const video = vo.row;
    const canPort = video.onlineStatus == 0;
    const canOnline = video.videoAuditStatus != 1 && video.onlineStatus == 0;
    const canOffline = video.videoAuditStatus != 1 && video.onlineStatus == 1;
    const canNotOnline = video.videoAuditStatus == 1 && video.onlineStatus == 0;
    const canNotOffline =
      video.videoAuditStatus == 1 && video.onlineStatus == 1;
    const canNotDelete = video.videoAuditStatus == 1 || video.onlineStatus == 1;
    const canNotEdit =
      video.videoAuditStatus == 1 ||
      video.enableShared == 0 ||
      video.onlineStatus == 1;
    const canQrCode =
      video.displayTypeName.indexOf("小程序") != -1 && video.onlineStatus == 1;
    const dealConf = [];
    if (canNotEdit) {
      dealConf.push(["icon-edit-disable", "编辑", () => {}, "video:update"]);
    } else {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => {
          router.push({ path: "/video/edit", query: { id: video.uuid } });
        },
        "video:update",
      ]);
    }

    if (canOnline) {
      dealConf.push([
        "icon-up",
        "上线",
        () => onlineVideo(video),
        "video:online",
      ]);
    } else if (canNotOnline) {
      dealConf.push(["icon-up-disable", "上线", () => {}, "video:online"]);
    } else if (canOffline) {
      dealConf.push([
        "icon-down",
        "下线",
        () => onlineVideo(video),
        "video:online",
      ]);
    } else if (canNotOffline) {
      dealConf.push(["icon-down-disable", "下线", () => {}, "video:online"]);
    }

    if (video.enableShared) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManage(video.uuid),
        "video:sharePage",
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "video:sharePage",
      ]);
    }

    if (canNotDelete) {
      dealConf.push(["icon-delete-disable", "删除", () => {}, "video:delete"]);
    } else {
      dealConf.push([
        "icon-delete",
        "删除",
        () => deleteVideo(video.uuid),
        "video:delete",
      ]);
    }

    if (canQrCode) {
      dealConf.push([
        "icon-qrcode",
        "下载二维码",
        () => qrcodeClick(video),
        "video:shareUrl",
      ]);
    } else {
      dealConf.push([
        "icon-qrcode-disable",
        "下载二维码",
        () => {},
        "video:shareUrl",
      ]);
    }

    if (canOnline) {
      dealConf.push([
        "iconfont icxiangshang3 iconfont-adapt",
        "上线申请",
        () => onlineVideoApply(video),
        "video:online:audit",
      ]);
    } else if (canNotOnline) {
      dealConf.push([
        "iconfont icxiangshang3 iconfont-adapt-disabled",
        "上线申请",
        () => {},
        "video:online:audit",
      ]);
    } else if (canOffline) {
      dealConf.push([
        "iconfont icxiangxia5 iconfont-adapt",
        "下线申请",
        () => onlineVideoApply(video),
        "video:online:audit",
      ]);
    } else if (canNotOffline) {
      dealConf.push([
        "iconfont icxiangxia5 iconfont-adapt-disabled",
        "下线申请",
        () => {},
        "video:online:audit",
      ]);
    }

    dealConf.push([
      video.onlineStatus == 1
        ? "iconfont icxiugaizhanshizhongduan iconfont-adapt-disabled"
        : "iconfont icxiugaizhanshizhongduan iconfont-adapt",
      "修改展示终端",
      video.onlineStatus == 1 ? () => {} : () => changePort(video),
      "video:updateDisplay",
    ]);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const VideoSetName = ({ props: { vo } }) => {
    return <span>{vo.row.videoSetName || "--"}</span>;
  };
  const CreateTime = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="table-row-column">
        <span>上线：{item.onlineDate}</span>
        <span>创建：{item.createDate}</span>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      width: "30",
    },
    {
      type: "expand",
      label: "",
      width: "30",
      render: (vo) => (
        <div class="detail_table">
          <el-form label-position="center" inline class="demo-table-expand">
            <el-row>
              <el-col span={4}>
                <el-form-item label="​视频类型：">
                  <span>{vo.row.videoTypeName}</span>
                </el-form-item>
              </el-col>
              <el-col span={3}>
                <el-form-item label="是否必修：">
                  <span>{vo.row.isRequiredName}</span>
                </el-form-item>
              </el-col>
              <el-col span={6}>
                <el-form-item label="视频来源：">
                  <span>{vo.row.videoSourceName}</span>
                </el-form-item>
              </el-col>
              <el-col span={3}>
                <el-form-item label="审核类型：">
                  <span>{vo.row.videoAuditTypeName}</span>
                </el-form-item>
              </el-col>
              <el-col span={3}>
                <el-form-item label="审核状态：">
                  <span>{vo.row.videoAuditStatusName}</span>
                </el-form-item>
              </el-col>
              <el-col span={5}>
                <el-form-item label="有效期：">
                  <span>{vo.row.expireTime}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col span={4}>
                <el-form-item label="版权方：">
                  <span>{vo.row.formDeptName || "--"}</span>
                </el-form-item>
              </el-col>
              <el-col span={4}>
                <el-form-item label="展示终端：">
                  <span>{vo.row.displayTypeName || "--"}</span>
                </el-form-item>
              </el-col>
              <el-col span={6}>
                <el-form-item label="已共享学院：">
                  <span>{vo.row.shareDeptName || "--"}</span>
                </el-form-item>
              </el-col>
              <el-col span={4}>
                <el-form-item label="安全审查：">
                  <span>{vo.row.safeCheckStatusName || "--"}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      ),
    },
    {
      label: "视频名称",
      minWidth: "200",
      // fixed: "left",
      // showOverflowTooltip: true,
      render: (vo) => (
        <div
          class="base-hover-char"
          onClick={() => {
            router.push({
              path: "/video/detail",
              query: { id: vo.row.uuid },
            });
          }}
        >
          {vo.row.videoName}
        </div>
      ),
    },
    {
      label: "所属视频集",
      prop: "videoSetName",
      minWidth: "120",
      render: (vo) => <VideoSetName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "视频分类",
      prop: "categoryName",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "讲师",
      prop: "lecturerName",
      width: "90",
      showOverflowTooltip: true,
    },
    {
      label: "学分",
      prop: "videoCredit",
      width: "64",
    },
    {
      label: "时长",
      prop: "videoLengthFormat",
      width: "64",
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      width: "64",
    },
    {
      label: "上线/创建时间",
      width: "220",
      render: (vo) => <CreateTime vo={vo} />,
    },
    {
      label: "操作",
      // fixed: "right",
      minWidth: "100",
      // width: "100",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
      onExpandChange={expandChange}
    />
  );
};

export default Table;
